export const accountCountryConfigurationCacheKeys = {
  getCountryConfiguration: () => ['country_configuration'] as const
}
